import { type FC, memo, useMemo } from 'react';
import type { GameV1 } from '@/api/games';
import { ImageComponent } from '@/components/Image';
import { getGameCover } from '@/helpers/cdn';
import { useCMSGameCovers } from '@/modules/common/hooks/useCMSGameCovers';
import {
  ScSmallLockedGameCardIcon,
  ScSmallLockedGameCardInner,
} from './styled';

interface ILockedGameCardProps {
  game: GameV1;
}

export const SmallLockedGameCard: FC<ILockedGameCardProps> = memo(
  ({ game }) => {
    const { id } = game;
    const { covers } = useCMSGameCovers();

    const url = useMemo(
      () => covers?.[id]?.cover?.url || getGameCover(id),
      [covers, id]
    );

    return (
      <ScSmallLockedGameCardInner>
        <ImageComponent
          alt="cover"
          className="cover-image"
          fill
          loading="lazy"
          src={url}
        />
        <div className="content">
          <ScSmallLockedGameCardIcon>
            <ImageComponent
              alt="play button icon"
              height={16}
              src="/game/lock-icon.svg"
              width={16}
            />
          </ScSmallLockedGameCardIcon>
        </div>
      </ScSmallLockedGameCardInner>
    );
  }
);
